import { PIPELINE_STAGES } from './revenueData';

type Props = {
  activeIndex?: number; // stages up to (and including) this index are highlighted
  compact?: boolean;
};

export default function PipelineStages({ activeIndex = -1, compact = false }: Props) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 rounded-md bg-foreground-950 text-accent-400 flex items-center justify-center text-lg"><i className="ri-flow-chart"></i></span>
          <h3 className="font-heading font-bold text-xl text-foreground-950">Automated campaign pipeline</h3>
        </div>
        <span className="bg-accent-100 text-accent-900 border border-accent-300 font-label font-bold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-sm whitespace-nowrap">
          Simulated stages
        </span>
      </div>

      {!compact && (
        <p className="mt-3 text-sm text-foreground-600">
          How a sponsorship would move through the platform once automation is built. Every stage shown is illustrative.
        </p>
      )}

      <ol className="mt-5 flex flex-wrap gap-2.5">
        {PIPELINE_STAGES.map((stage, i) => {
          const reached = i <= activeIndex;
          return (
            <li key={stage} className="flex items-center gap-2.5">
              <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border font-label uppercase tracking-wide text-[10px] font-semibold whitespace-nowrap ${reached ? 'bg-primary-500 border-primary-500 text-background-50' : 'bg-background-100 border-background-200 text-foreground-500'}`}>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={reached ? 'ri-check-line' : 'ri-circle-line'}></i>
                </span>
                {stage}
              </span>
              {i < PIPELINE_STAGES.length - 1 && (
                <span className="w-4 flex items-center justify-center text-foreground-300"><i className="ri-arrow-right-line"></i></span>
              )}
            </li>
          );
        })}
      </ol>

      <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
        {[
          { icon: 'ri-sparkling-line', label: 'AI preparation', text: 'Creative is drafted automatically for review.' },
          { icon: 'ri-bank-card-line', label: 'Payment confirmation', text: 'Simulated — no real charge is made.' },
          { icon: 'ri-rocket-line', label: 'Campaign activation', text: 'Scheduling and go-live are simulated.' },
        ].map((n) => (
          <div key={n.label} className="flex items-start gap-3 rounded-md border border-background-200 bg-background-100 px-4 py-3">
            <span className="w-5 h-5 flex items-center justify-center text-accent-700 shrink-0 mt-0.5"><i className={n.icon}></i></span>
            <div>
              <p className="font-label uppercase tracking-widest text-[10px] font-bold text-foreground-800">{n.label}</p>
              <p className="text-xs text-foreground-600 mt-0.5">{n.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}